import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import Button from "@material-ui/core/Button";
import CardBody from "components/Card/CardBody.js";
import Divider from "@material-ui/core/Divider";
import Alert from "@material-ui/lab/Alert";
import { EmojiPeople } from "@material-ui/icons";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Slide from "@material-ui/core/Slide";
import Skeleton from "@material-ui/lab/Skeleton";

// SELECT
import LoadGender from "components/services/LoadGender";

import { cardStyle } from "assets/jss/material-dashboard-react/components/cardStyle";

const useStyles = makeStyles(cardStyle);

export default function ContactPerson() {
  const classes = useStyles();
  const [loader, setLoader] = useState(true);
  const [openAlertsuccess, setOpenAlertsuccess] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje_error, setMensaje_error] = useState("");
  const [openBackdrop, setoOpenBackdrop] = useState(false);
  const [mensaje_success, setMensaje_success] = useState("");
  const [errorServer, setErrorServer] = useState(false);

  let keyAuthorization = localStorage.getItem("Session");

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    stakeholder_id: "",
    nameContact: "",
    lastNameContact: "",
    documentContact: "",
    email: "",
    nameCompany: "",
    phoneContact: "",
    genderContact: "",
    genderContactData: "",
    /* ALERT ERROR */
    errorGenderContact: false,
    errorFieldnameContact: false,
    errorFieldlastNameContact: false,
    errorFielddocumentContact: false,
    errorFieldEmail: false,
    errorFieldphoneContact: false,
  });

  useEffect(() => {
    axios
      .get(`${urlServices}stakeholders/user/${localStorage.getItem("id")}`, {
        headers: {
          application: keyAplication,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log(response.data)
            setValues({
              ...values,
              stakeholder_id: response.data.id,
              nameContact: response.data.name,
              lastNameContact: response.data.last_name,
              documentContact: response.data.document_id,
              email: response.data.email,
              phoneContact: response.data.phone,
              genderContact: response.data.gender_id,
              genderContactData: {
                id: response.data.gender_id,
                detailName: response.data.gender_name,
              },
            });
            setLoader(false);
          }
        },
        (error) => {
          console.log(error);
          setErrorServer(true);
        }
      );
  }, [urlServices, keyAplication]);

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorFieldnameContact: false,
      errorFieldlastNameContact: false,
      errorFielddocumentContact: false,
      errorFieldEmail: false,
      errorFieldphoneContact: false,
    });
  };

  const getResponseGender = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        genderContact: pro.code,
        genderContactData: pro,
        errorGenderContact: false,
      });
    } else {
      setValues({
        ...values,
        genderContact: "",
        genderContactData: pro,
      });
    }
  };

  const submitForm = (e) => {
    e.preventDefault();

    setOpenAlertsuccess(false);

    if (values.nameContact.length === 0) {
      setValues({
        ...values,
        errorFieldnameContact: true,
      });
      setMensaje_error('El campo "Nombre" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.lastNameContact.length === 0) {
      setValues({
        ...values,
        errorFieldlastNameContact: true,
      });
      setMensaje_error('El campo "Apellidos" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.documentContact.length === 0) {
      setValues({
        ...values,
        errorFielddocumentContact: true,
      });
      setMensaje_error('El campo "Cédula" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.email.length === 0) {
      setValues({
        ...values,
        errorFieldEmail: true,
      });
      setMensaje_error('El campo "Correo Electrónico" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (!values.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      setValues({
        ...values,
        errorFieldEmail: true,
      });
      setMensaje_error('El campo "Correo Electrónico" no es válido!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.phoneContact.length === 0) {
      setValues({
        ...values,
        errorFieldphoneContact: true,
      });
      setMensaje_error('El campo "Teléfono" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.genderContact.length === 0) {
      setValues({
        ...values,
        errorGenderContact: true,
      });
      setMensaje_error('El campo "Género" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else {
      setoOpenBackdrop(true);

      const dataValues = {
        name: values.nameContact,
        last_name: values.lastNameContact,
        document_id: values.documentContact,
        email: values.email.toLowerCase(),
        phone: values.phoneContact,
        gender_id: values.genderContact,
      };

      axios
        .put(
          `${urlServices}stakeholders/${values.stakeholder_id}`,
          dataValues,
          {
            headers: {
              application: keyAplication,
              Authorization: "Bearer " + keyAuthorization,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            setOpenAlertsuccess(true);
            setMensaje_success("Registro guardado con exito!");
            setoOpenBackdrop(false);
          }
        })
        .catch((e) => {
          if (e.response.status === 402) {
            setMensaje_error("Error al registrar los datos");
            setOpenAlert(true);
            setoOpenBackdrop(false);
          } else {
            setMensaje_error("Error al registrar los datos");
            setOpenAlert(true);
            console.log(e);
            setoOpenBackdrop(false);
          }
        });
    }
  };

  const handleClose = (event, reason) => {
    setOpenAlert(false);
    setOpenAlertsuccess(false);
  };

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardBody>
              <Grid container spacing={2} className={classes.containerStyle}>
                <Grid item xs={12} sm={12}>
                  <div className={classes.titleCardSub2}>
                    <EmojiPeople className={classes.iconSubTitle} />
                    PERSONA DE CONTACTO
                  </div>
                  <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
                </Grid>

                <Grid item xs={12} sm={12}>
                  {errorServer ? (
                    <Alert severity="error">
                      Error en la consulta al servidor
                    </Alert>
                  ) : (
                    ""
                  )}
                </Grid>
                {loader ? (
                  <Fragment>
                    <Grid item xs={12} md={6}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <center>
                        <Skeleton width={120} height={40} />
                      </center>
                    </Grid>
                  </Fragment>
                ) : (
                  <Fragment>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        name="nameContact"
                        value={values.nameContact}
                        error={values.errorFieldnameContact}
                        onChange={handleChange("nameContact")}
                        fullWidth
                        required
                        inputProps={{ maxLength: 100 }}
                        autoComplete="off"
                        label="Nombre"
                        //helperText="Error"
                        margin="dense"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        name="lastNameContact"
                        value={values.lastNameContact}
                        error={values.errorFieldlastNameContact}
                        onChange={handleChange("lastNameContact")}
                        fullWidth
                        required
                        inputProps={{ maxLength: 100 }}
                        autoComplete="off"
                        label="Apellidos"
                        //helperText="Error"
                        margin="dense"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={values.errorFielddocumentContact}
                        name="documentContact"
                        value={values.documentContact}
                        onChange={handleChange("documentContact")}
                        fullWidth
                        required
                        inputProps={{ maxLength: 12 }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                        autoComplete="off"
                        label="Cédula"
                        margin="dense"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={values.errorFieldEmail}
                        name="email"
                        value={values.email}
                        onChange={handleChange("email")}
                        /* onInput={(e) => {
               handleValidate(e.target.value);
            }}*/
                        fullWidth
                        required
                        inputProps={{ maxLength: 150 }}
                        autoComplete="off"
                        label="Correo electrónico"
                        margin="dense"
                        //   helperText={mensaje_validate}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={values.errorFieldphoneContact}
                        name="phoneContact"
                        value={values.phoneContact}
                        onChange={handleChange("phoneContact")}
                        fullWidth
                        required
                        inputProps={{ maxLength: 12 }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                        autoComplete="off"
                        label="Teléfono"
                        margin="dense"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <LoadGender
                        callback={getResponseGender}
                        value={values.genderContactData}
                        error={values.errorGenderContact}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <center>
                        {openAlertsuccess ? (
                          <Alert severity="success">{mensaje_success}</Alert>
                        ) : (
                          ""
                        )}
                      </center>
                    </Grid>
                    <Grid item xs={12} sm={12} style={{ margin: "50px 0" }}>
                      <center>
                        <Button
                          onClick={submitForm}
                          className={classes.buttonSubmit}
                        >
                          Guardar
                        </Button>
                      </center>
                    </Grid>
                  </Fragment>
                )}
              </Grid>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <Backdrop
        style={{ zIndex: "9999", color: "#FFFFFF" }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
          <Alert
            onClose={handleClose}
            severity="error"
            elevation={6}
            variant="filled"
          >
            {mensaje_error}
          </Alert>
        </Slide>
      </Snackbar>
    </Fragment>
  );
}
